var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgErrorIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 51,
    viewBox: "0 0 50 51",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M41.4046 41.9414C41.3585 42.1084 41.2875 42.2697 41.1973 42.4176L41.4046 41.9414Z",
    fill: "url(#paint0_linear_22324_23785)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M44.8122 36.5104L28.1811 7.70466C27.5168 6.55458 26.3283 5.86914 24.9997 5.86914C23.673 5.86914 22.4826 6.55458 21.8182 7.70466L5.18719 36.5104C4.65919 37.4263 4.54783 38.5207 4.88575 39.5171L4.91071 39.5843C4.97023 39.7437 5.02783 39.88 5.09503 40.0087L6.07615 42.2839L6.13183 42.4106C6.72127 43.6835 7.95583 44.4746 9.35359 44.4746H40.6477C41.8938 44.4746 43.0246 43.841 43.6717 42.7811L44.887 40.0451C44.9773 39.8723 45.0541 39.6919 45.1136 39.5133C45.4496 38.5187 45.3402 37.4224 44.8122 36.5085V36.5104Z",
    fill: "#260512"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M43.4824 37.2786L26.8513 8.47473C26.0277 7.05009 23.9713 7.05009 23.1496 8.47473L6.51855 37.2786C6.18831 37.8488 6.15567 38.4767 6.34191 39.0239L6.34575 39.0335C6.38223 39.1371 6.42447 39.237 6.47631 39.3349H6.47823C6.68751 39.74 7.02543 40.0779 7.44975 40.2795C7.72431 40.412 8.03343 40.485 8.37135 40.485H41.6315C41.9694 40.485 42.2805 40.4101 42.5531 40.2795C42.9621 40.0837 43.2923 39.7631 43.5035 39.3771C43.5649 39.2638 43.6168 39.1467 43.6571 39.0239C43.8414 38.4767 43.8088 37.8488 43.4805 37.2786H43.4824ZM41.453 38.7915H8.24847C7.86639 38.7915 7.62639 38.3787 7.81839 38.0466C13.3768 28.46 18.9352 18.8735 24.4917 9.28497C24.7816 8.78769 25.5035 8.78961 25.7896 9.29073C31.2059 18.7851 36.6242 28.2795 42.0405 37.7739C42.2997 38.2271 41.9733 38.7915 41.451 38.7915H41.453Z",
    fill: "#66451E"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M41.4522 38.7921H8.24768C7.8656 38.7921 7.6256 38.3793 7.8176 38.0472C13.376 28.4606 18.9344 18.8741 24.4909 9.28559C24.7808 8.78831 25.5027 8.79023 25.7888 9.29135C31.2051 18.7857 36.6234 28.2801 42.0397 37.7745C42.2989 38.2277 41.9725 38.7921 41.4502 38.7921H41.4522Z",
    fill: "url(#paint1_linear_22324_23785)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M41.4522 38.7921H8.24768C7.8656 38.7921 7.6256 38.3793 7.8176 38.0472C13.376 28.4606 18.9344 18.8741 24.4909 9.28559C24.7808 8.78831 25.5027 8.79023 25.7888 9.29135C31.2051 18.7857 36.6234 28.2801 42.0397 37.7745C42.2989 38.2277 41.9725 38.7921 41.4502 38.7921H41.4522Z",
    fill: "url(#paint2_linear_22324_23785)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M43.5057 39.3782L42.588 41.4672L42.3652 41.9779V41.9817C42.0196 42.5443 41.4014 42.9417 40.6488 42.9417H9.35276C8.50604 42.9417 7.83596 42.4425 7.52492 41.7686L7.49036 41.686L6.47852 39.3379C6.6878 39.7411 7.02572 40.079 7.45004 40.2806C7.7246 40.4131 8.03372 40.486 8.37164 40.486H41.6318C41.9697 40.486 42.2808 40.4112 42.5534 40.2806C42.9624 40.0848 43.2926 39.7641 43.5038 39.3782H43.5057Z",
    fill: "#422D11"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "overlay"
    },
    d: "M24.9147 36.8069C30.522 36.8069 35.0676 33.9719 35.0676 30.4747C35.0676 26.9776 30.522 24.1426 24.9147 24.1426C19.3074 24.1426 14.7617 26.9776 14.7617 30.4747C14.7617 33.9719 19.3074 36.8069 24.9147 36.8069Z",
    fill: "url(#paint3_linear_22324_23785)"
  }), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M27.7659 18.3566L26.7445 30.1243C26.731 30.514 26.4123 30.8212 26.0206 30.8212H24.404C24.0699 30.8212 23.7896 30.5985 23.707 30.2913C23.8165 30.3566 23.9451 30.395 24.0814 30.395H25.6981C26.0878 30.395 26.4066 30.0859 26.4219 29.698L27.4434 17.9284C27.4491 17.7825 27.4222 17.6423 27.3723 17.5156C27.6219 17.7095 27.7813 18.0148 27.7659 18.3566Z",
    fill: "#422D11"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M27.4443 17.9267L26.4228 29.6963C26.4094 30.0842 26.0887 30.3933 25.699 30.3933H24.0823C23.946 30.3933 23.8174 30.3549 23.7079 30.2896C23.6945 30.2359 23.683 30.1802 23.6811 30.1226L22.4676 18.3549C22.4446 17.7808 22.9073 17.3027 23.4795 17.3027H26.7531C26.9873 17.3027 27.2004 17.3815 27.3713 17.5139C27.4212 17.6407 27.4481 17.7808 27.4423 17.9267H27.4443Z",
    fill: "url(#paint4_linear_22324_23785)"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.78,
    d: "M26.0544 27.6808L23.8061 27.6655C23.5315 24.5704 23.257 21.4735 22.9824 18.3784C22.9574 18.0943 23.1782 17.8485 23.4624 17.8428C24.505 17.8216 25.5456 17.8005 26.5882 17.7794C26.8474 17.7736 27.0528 17.9964 27.0259 18.2556C26.7014 21.3967 26.3789 24.5397 26.0544 27.6808Z",
    fill: "url(#paint5_linear_22324_23785)"
  }), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M26.6893 33.2275C26.6893 34.0781 26 34.7674 25.1494 34.7674C24.5849 34.7674 24.0934 34.4621 23.8265 34.009C23.7536 33.8918 23.6787 33.7594 23.6077 33.6096C23.5693 33.527 23.5366 33.4464 23.5078 33.3715C23.8649 33.9302 24.4832 34.2432 25.0669 34.1568C25.8502 34.0416 26.4857 33.2218 26.3801 32.2637C26.4339 32.3654 26.4877 32.4672 26.5414 32.569C26.6374 32.7706 26.6893 32.9914 26.6893 33.2294V33.2275Z",
    fill: "url(#paint6_linear_22324_23785)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M26.4957 32.8406C26.4957 33.6912 25.8064 34.3805 24.9559 34.3805C24.4336 34.3805 23.9728 34.1232 23.6963 33.7238C23.6618 33.6777 23.6291 33.6259 23.6023 33.576L23.5869 33.5453C23.4775 33.3341 23.416 33.0941 23.416 32.8406C23.416 31.9901 24.1053 31.3008 24.9559 31.3008C25.4877 31.3008 25.9581 31.5715 26.2346 31.9805L26.2403 31.9901C26.2979 32.0726 26.3459 32.1648 26.3824 32.2608C26.3959 32.2934 26.4093 32.3241 26.417 32.3568C26.4688 32.5085 26.4957 32.6717 26.4957 32.8406Z",
    fill: "url(#paint7_linear_22324_23785)"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.78,
    d: "M23.8264 32.0775C24.0587 31.7607 24.4427 31.465 25.059 31.5034C25.4661 31.5283 25.8462 31.7472 26.0786 32.0832C26.2494 32.329 26.3493 32.617 26.0728 32.784C25.6312 33.0509 24.8459 32.304 24.0779 32.4595C23.861 32.5037 23.6939 32.2579 23.8264 32.0775Z",
    fill: "url(#paint8_linear_22324_23785)"
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.61
  }, _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M24.6189 10.1076L22.2419 14.4583C21.255 16.2651 22.5626 18.4673 24.6208 18.4673H25.6288C27.6755 18.4673 28.985 16.2843 28.0192 14.4795L25.6845 10.1134C25.4579 9.68906 24.8493 9.68522 24.6189 10.1076Z",
    fill: "#FCF9E8"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_22324_23785",
    x1: 41.3009,
    y1: 42.0758,
    x2: 41.3009,
    y2: 42.4252,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FE920E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E45E14"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_22324_23785",
    x1: 24.9402,
    y1: 12.6302,
    x2: 24.9402,
    y2: 47.6779,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FDEAB0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#FCDC63"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#FBD433"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#FBD121"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#FACD1F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#F7C11C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#F3AC16"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#EE900D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#E76D02"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E66801"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_22324_23785",
    x1: 24.9402,
    y1: 10.0344,
    x2: 24.9402,
    y2: 47.5896,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FEEBB3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    stopColor: "#FCE17B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    stopColor: "#FBD121"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#FACD1F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#F7C11C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "#F3AC16"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    stopColor: "#EE900D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#E76D02"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E66801"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_22324_23785",
    x1: 24.8129,
    y1: 27.5679,
    x2: 25.0587,
    y2: 34.5797,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBD121",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#FBD120",
    stopOpacity: 0.12
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#FBD11E",
    stopOpacity: 0.18
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    stopColor: "#FBD21A",
    stopOpacity: 0.28
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#FCD315",
    stopOpacity: 0.41
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#FDD40F",
    stopOpacity: 0.58
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    stopColor: "#FED608",
    stopOpacity: 0.79
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFD801"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_22324_23785",
    x1: 24.9329,
    y1: 14.7971,
    x2: 25.0673,
    y2: 33.2023,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    stopColor: "#66451E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    stopColor: "#5B3D1A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#422D11"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_22324_23785",
    x1: 25.0042,
    y1: 13.4671,
    x2: 25.0042,
    y2: 26.2754,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EABF8F",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#E3B989",
    stopOpacity: 0.48
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#D1A879",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#B48D5E",
    stopOpacity: 0.29
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#8B6739",
    stopOpacity: 0.13
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.98,
    stopColor: "#6B491C",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_22324_23785",
    x1: 23.2448,
    y1: 30.1978,
    x2: 25.2435,
    y2: 33.3562,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    stopColor: "#66451E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    stopColor: "#5B3D1A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#422D11"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_22324_23785",
    x1: 25.7085,
    y1: 35.5824,
    x2: 24.1783,
    y2: 30.0182,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    stopColor: "#66451E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    stopColor: "#5B3D1A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#422D11"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_22324_23785",
    x1: 25.2971,
    y1: 30.5875,
    x2: 24.9861,
    y2: 32.5421,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EABF8F",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#E3B989",
    stopOpacity: 0.48
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#D1A879",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#B48D5E",
    stopOpacity: 0.29
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#8B6739",
    stopOpacity: 0.13
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.98,
    stopColor: "#6B491C",
    stopOpacity: 0
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgErrorIcon);
export default __webpack_public_path__ + "static/media/errorIcon.c08df39fc2e19c5d5d47c5c1376bc58f.svg";
export { ForwardRef as ReactComponent };